/**
 * Route guard (web/docs/data-layer.md §Route guards). Wraps the app-shell
 * routes; public routes stay outside it. While the boot-time session restore
 * is in flight it renders nothing — redirecting during `loading` would flash
 * `/login` to a user whose refresh token is about to succeed.
 */

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from './authContext';

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return null;
  if (status === 'unauthenticated') {
    const next = location.pathname + location.search;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <Outlet />;
}
